import { StatusBar } from 'expo-status-bar'
import { createNativeStackNavigator } from '@react-navigation/native-stack'

// screens & components
import HomeScreen from '../screens/home/HomeScreen'
import StoreInformationScreen from '../screens/home/StoreInformationScreen'
import PersonalBasicInfromationScreen from '../screens/home/PersonalBasicInfromationScreen'
import ConfirmPersonalInfromationScreen from '../screens/home/ConfirmPersonalInfromationScreen'
import ScheduleAvailabilityScreen from '../screens/home/ScheduleAvailabilityScreen'
import OnBoardingFormsScreen from '../screens/home/OnBoardingFormsScreen'
import PersonalContactInfromationScreen from '../screens/home/PersonalContactInfromationScreen'
import DailyAvailabilityScreen from '../screens/home/DailyAvailabilityScreen'
import ConfirmScheduleAvailabilityScreen from '../screens/home/ConfirmScheduleAvailabilityScreen'
import CommunicateWithAdminScreen from '../screens/home/CommunicateWithAdminScreen'
import NewMessageScreen from '../screens/communication/NewMessageScreen'
import MessageScreen from '../screens/communication/MessageScreen'
import ProfileScreen from '../screens/home/ProfileScreen'
import ScheduleAvailabilityReadOnlyScreen from '../screens/home/ScheduleAvailabilityReadOnlyScreen'
import HelpScreen from '../screens/home/HelpScreen'
import LanguageScreen from '../screens/home/LanguageScreen'
import ProfileViewscreen from '../screens/home/ProfileViewscreen'
import UpdateDeposit from '../components/board/directdeposit/UpdateDeposit'

// skeletons
import CommunicateSkeleton from '../skeletons/CommunicateSkeleton'
import HomeSkeleton from '../skeletons/HomeSkeleton'
import OnBoardingFormsSkeleton from '../skeletons/OnBoardingFormsSkeleton'
import PersonalBasicInfoSkeleton from '../skeletons/PersonalBasicInfoSkeleton'
import PersonalContactInfoSkeleton from '../skeletons/PersonalContactInfoSkeleton'
import ScheduleSkeleton from '../skeletons/ScheduleSkeleton'
import StoreSkeleton from '../skeletons/StoreSkeleton'
import LabourScreen from '../screens/home/Labour/LabourScreen'
import EarningsScreen from '../screens/home/paystub/EarningsScreen'
import Switchaccount from '../screens/home/Switchaccount'
import LaborSavorSchedule from '../screens/home/Labour/LabourSavorSchedule'
import Clockin from '../screens/home/Labour/Clockin'
import Takebreak from '../screens/home/Labour/Takebreak'
import Endbreak from '../screens/home/Labour/Endbreak'
import ClockOut from '../screens/home/Labour/ClockOut'
import Transfer from '../screens/home/Labour/Transfer'
import PayrollDocuments from '../screens/home/paystub/payrollDocuments'
import PayCheckDetails from '../screens/home/paystub/PayCheckDetails'
import Giveup from '../screens/home/shift/Giveup'
import WelcomeSlider from '../screens/home/welcome/WelcomeSlider'
import Vieww2 from '../screens/home/paystub/Vieww2'
import DepartmentMessages from '../screens/communication/DepartmentMessages'
import MessageNew from '../screens/communication/MessageNew'
import ChatScreen from '../screens/communication/CommunicationwithDepartment'
import OnboardedMessages from '../screens/communication/Messages'
import EmployeeResources from '../screens/home/EmployeeResources'
import EmployeeRequest from '../screens/home/EmployeeRequest'
import Pickup from '../screens/home/shift/pickup'
import SwapShift from '../screens/home/shift/SwapShift'
import UpdateScheduleAvailability from '../screens/home/shift/UpdateScheduleAvailability'
import EmployeeRequestPTO from '../screens/home/EmployeeRequestPTO'
import W4InformationForm from '../components/board/w4online/W4InformationForm'
import Editdirectdeposit from '../components/board/directdeposit/Editdirectdeposit'
import I9InformationForm from '../components/board/i9online/I9InformationForm'
import W4preview from '../components/board/w4online/W4preview'
import Directdepositonline from '../components/board/directdeposit/Directdepositonline'
import I9informationonline from '../components/board/i9online/I9informationonline'
import AlinformationForm from '../components/board/alonline/AlinformationForm'
import Alonline from '../components/board/alonline/Alonline'
import IoInformatiomForm from '../components/board/Ioonline/IoInformationForm'
import Ioinformationonline from '../components/board/Ioonline/IoInformationonline'
import WotcInformationForm from '../components/board/wotconline/WotcInformationForm'
import Wotconline from '../components/board/wotconline/Wotconline'

import UpdatePersonalContactInformationScreen from '../screens/home/UpdatePersonalContactInformationScreen'
import UpdatePersonalBasicInformationScreen from '../screens/home/UpdatepersonalBasicInformationScreen'
import UpdateBasicInformationForm from '../components/home/forms/UpdateBasicInformationForm'
import UpdateContactInformationForm from '../components/home/forms/UpdateContactInformationForm'
import LaInformationForm from '../components/board/laonline/LaInformationForm'
import LAInformationOnline from '../components/board/laonline/LAInformationOnline'
import GaInformationForm from '../components/board/gaonline/GaInformationForm'
import GAInformationOnline from '../components/board/gaonline/GAInformationOnline'
import CAonline from '../components/board/caonline/Caonline'
import CAinformationForm from '../components/board/caonline/CainformationForm'
import ARinformationForm from '../components/board/aronline/ARinformationForm'
import ARinformationonline from '../components/board/aronline/ARinformationonline'
import KyInformationForm from '../components/board/kyonline/KyInformationForm'
import KyInformationonline from '../components/board/kyonline/KyInformationonline'
import CtinformationForm from '../components/board/ctonline/CtinformationForm'
import Ctonline from '../components/board/ctonline/Ctonline'
import CoinformationForm from '../components/board/coonline/CoinformationForm'
import Coonline from '../components/board/coonline/Coonline'
import AZinformationonline from '../components/board/azonline/AZinformationonline'
import AZinformationForm from '../components/board/azonline/AZinformationForm'
import DCinformationForm from '../components/board/dconline/DCinformationForm'
import DConline from '../components/board/dconline/DConline'
import HiinformationForm from '../components/board/hionline/HiinformationForm'
import Hionline from '../components/board/hionline/Hionline'
import DeinformationForm from '../components/board/deonline/DeinformationForm'
import Deonline from '../components/board/deonline/Deonline'
import IdinformationForm from '../components/board/idonline/IdinformationForm'
import Idonline from '../components/board/idonline/Idonline'
import PainformationForm from '../components/board/paonline/PaInformationForm'
import MainformationForm from '../components/board/maonline/MaInformationForm'
import MaInformationonline from '../components/board/maonline/MaInformationOnline'
import MdInformationForm from '../components/board/mdonline/MdInformationForm'
import MdInformationOnline from '../components/board/mdonline/MdInformationOnline'
import KarnsInformationForm from "../components/board/karnsonline/KarnsInformationForm"
import KarnsInformationOnline from "../components/board/karnsonline/KarnsInformationOnline"
import WCRightsInformationForm from '../components/board/wcrightsonline/WCRightsInformationForm'
import WCRightsInformationOnline from '../components/board/wcrightsonline/WCRightsInformationOnline'
import EEOInformationForm from '../components/board/eeoonline/EEOInformationForm'
import EEOInformationOnline from '../components/board/eeoonline/EEOInformationOnline'
import OkInformationForm from '../components/board/okonline/OkInformationForm'
import OkInformationOnline from '../components/board/okonline/OkInformationOnline'
import KsinformationOnline from '../components/board/ksonline/KsinformationOnline'
import KsinformationForm from '../components/board/ksonline/KsinformationForm'
import VaInformationForm from '../components/board/vaonline/VaInformationForm'
import VaInformationOnline from '../components/board/vaonline/VaInformationOnline'
import Form8850InformationForm from '../components/board/8850/Form8850InformationForm'
import Form8850InformationOnline from '../components/board/8850/Form8850InformationOnline'
import OrInformationForm from '../components/board/oronline/OrInformationForm'
import OrInformationOnline from '../components/board/oronline/OrInformationOnline'
import MoInformationform from '../components/board/moonline/MoInformationform'
import MoInformationonline from '../components/board/moonline/MoInformationonline'
import HandBookOnline from '../components/board/grocerybasketofgrenade/HandBookOnline'
import CellPhonePolicy from '../components/board/grocerybasketofgrenade/CellPhonePolicy'
import Maintenance from '../screens/home/loginerror/Maintenance'
import MsInformationform from '../components/board/msonline/MsInformationForm'
import MsInformationOnline from '../components/board/msonline/MsInformationOnline'
import IlInformationForm from '../components/board/ilonline/IlInformationForm'
import IlInformationOnline from '../components/board/ilonline/IlInformationOnline'
import WiInformationForm from '../components/board/wionline/WiInformationForm'
import WiInformationOnline from '../components/board/wionline/WiInformationOnline'
import InInformationForm from '../components/board/inonline/InInformationForm'
import InInformationOnline from '../components/board/inonline/InInformationOnline'
import MtInformationForm from '../components/board/mtonline/MtInformationForm'
import MtInformationOnline from '../components/board/mtonline/MtInformationOnline'
import RiInformationOnline from '../components/board/rionline/RiInformationOnline'
import RiInformationForm from '../components/board/rionline/RiInformationForm'
import NeInformationForm from '../components/board/neonline/NeInformationForm'
import NeInformationOnline from '../components/board/neonline/NeInformationOnline'
import ScInformationForm from '../components/board/sconline/ScInformationForm'
import ScInformationOnline from '../components/board/sconline/ScInformationOnline'
import VtInformationForm from '../components/board/vtonline/VtInformationForm'
import VtInformationOnline from '../components/board/vtonline/VtInformationOnline'
import WvInformationForm from '../components/board/wvonline/WvInformationForm'
import WvInformationOnline from '../components/board/wvonline/WvInformationOnline'
import MeInformationForm from '../components/board/meonline/MeInformationForm'
import OhInformationForm from '../components/board/ohonline/OhInformationForm'
import OhInformationOnline from '../components/board/ohonline/OhInformationOnline'
import MeInformationOnline from '../components/board/meonline/MeInformationonline'
import MiInformationForm from '../components/board/mionline/MiInformationForm'
import MiInformationOnline from '../components/board/mionline/MiInformationOnline'
import CanarayForm from '../components/board/CanarayForm'
import NjInformationForm from '../components/board/njonline/NjInformationForm'
import NjInformationOnline from '../components/board/njonline/NjInformationOnline'
import NmInformationForm from '../components/board/nmonline/NmInformationForm'
import NmInformationOnline from '../components/board/nmonline/NmInformationOnline'
import NcInformationForm from '../components/board/nconline/NcInformationForm'
import NcInformationOnline from '../components/board/nconline/NcInformationOnline'
import Operations from '../components/board/customForms/Redmonds/Operations'
import HandBook from '../components/board/customForms/Redmonds/HandBook'
import NyInformationForm from '../components/board/nyonline/NyInformationForm'
import NyInformationOnline from '../components/board/nyonline/NyInformationOnline'
import RobertsAcknowledgement from '../components/board/customForms/Roberts/RobertsAcknowledgement'
import MnInformationForm from '../components/board/mnonline/MnInformationForm'
import MnInformationOnline from '../components/board/mnonline/MnInformationOnline'
import PainformationTable from '../components/board/paonline/painformationTable'
import Acknowledgment from '../components/board/customForms/wakefield/Acknowledgment'
import HandBookSignOffOnline from '../components/board/customForms/Jprouxl/HandBookSignOffOnline'
import HandBookSignOffForm from '../components/board/customForms/Jprouxl/HandbookSignOffForm'
import RonsHandBook from '../components/board/customForms/Rons/RonsHandBook'
import CityMarketsAcknowledgement from '../components/board/customForms/CityMarkets/CityMarketsAcknowledgement'
import DavisTeamDiscountPolicy from '../components/board/customForms/Davis/DavisTeamDiscountPolicy'
import FoodCountryForm from '../components/board/customForms/foodcountry/FoodCountryForm'
import WeeklySummary from '../screens/home/Labour/WeeklySummary'
import AnnouncementsScreen from '../screens/home/Labour/AnnouncementsScreen'
import GalensAcknowledgement from '../components/board/customForms/galens/GalensAcknowledgement'
import PTORequestHistory from '../screens/home/PTORequestHistory'
import TimeCard from '../screens/home/Labour/TimeCard'
import CommunicateWithEmployee from '../screens/communication/CommunicateWithEmployee'
import SecondaryStack from './SecondaryStack'
import PaInformationonline from '../components/board/paonline/paInformationonline'

const Stack = createNativeStackNavigator()

const HomeStack = ({ route }): JSX.Element => {
  const { params } = route

  return (
    <Stack.Navigator
      initialRouteName="Onboarding"
      screenOptions={{ headerShown: false, animation: 'fade_from_bottom' }}
    >
      {/* <Stack.Screen
        options={{ headerShown: false }}
        name="WelcomeSlider"
        component={WelcomeSlider}
        initialParams={{ ...params }}
      /> */}
      <Stack.Screen
        options={{ title: 'Maintenance', headerShown: false }}
        name="Maintenance"
        component={Maintenance}
        initialParams={{ ...params }}
      />

      <Stack.Screen
        options={{ title: 'Onboarding - Workhappy', headerShown: false }}
        name="Onboarding"
        component={HomeScreen}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{ title: 'Store Information - Workhappy', headerShown: false }}
        name="StoreInformation"
        component={StoreInformationScreen}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'Personal Basic Information - Workhappy',
          headerShown: false
        }}
        name="PersonalBasicInformation"
        component={PersonalBasicInfromationScreen}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'Personal Contact Information - Workhappy',
          headerShown: false
        }}
        name="PersonalContactInfromation"
        component={PersonalContactInfromationScreen}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{ headerShown: false }}
        name="ConfirmPersonalInfromation"
        component={ConfirmPersonalInfromationScreen}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{ title: 'OnboardingForms - Workhappy', headerShown: false }}
        name="OnboardingForms"
        component={OnBoardingFormsScreen}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'Schedule Availability - Workhappy',
          headerShown: false
        }}
        name="ScheduleAvailability"
        component={ScheduleAvailabilityScreen}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'Schedule Availability - Workhappy',
          headerShown: false
        }}
        name="ScheduleAvailabilityReadOnly"
        component={ScheduleAvailabilityReadOnlyScreen}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{ headerShown: false }}
        name="DailyAvailability"
        component={DailyAvailabilityScreen}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{ headerShown: false }}
        name="ConfirmScheduleAvailability"
        component={ConfirmScheduleAvailabilityScreen}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'Messages - Workhappy',
          headerShown: false
        }}
        name="CommunicateWithAdmin"
        component={CommunicateWithAdminScreen}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'New Message - Workhappy',
          headerShown: false
        }}
        name="NewMessage"
        component={NewMessageScreen}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: ' Message - Workhappy',
          headerShown: false
        }}
        name="Message"
        component={MessageScreen}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: ' Profile - Workhappy',
          headerShown: false
        }}
        name="Profile"
        component={ProfileScreen}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: ' Help - Workhappy',
          headerShown: false
        }}
        name="Help"
        component={HelpScreen}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{ headerShown: false }}
        name="CommunicateSkeleton"
        component={CommunicateSkeleton}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{ headerShown: false }}
        name="HomeSkeleton"
        component={HomeSkeleton}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{ headerShown: false }}
        name="OnBoardingFormsSkeleton"
        component={OnBoardingFormsSkeleton}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{ headerShown: false }}
        name="PersonalBasicInfoSkeleton"
        component={PersonalBasicInfoSkeleton}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{ headerShown: false }}
        name="PersonalContactInfoSkeleton"
        component={PersonalContactInfoSkeleton}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{ headerShown: false }}
        name="ScheduleSkeleton"
        component={ScheduleSkeleton}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{ headerShown: false }}
        name="StoreSkeleton"
        component={StoreSkeleton}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: ' Dashboard - Workhappy',
          headerShown: false
        }}
        name="LabourScreen"
        component={LabourScreen}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: ' Earnings - Workhappy',
          headerShown: false
        }}
        name="EarningsScreen"
        component={EarningsScreen}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: ' Settings - Workhappy',
          headerShown: false
        }}
        name="Languagescreen"
        component={LanguageScreen}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: ' My Profile  - Workhappy',
          headerShown: false
        }}
        name="ProfileView"
        component={ProfileViewscreen}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{ headerShown: false }}
        name="Switchscreen"
        component={Switchaccount}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: ' Shifts - Workhappy',
          headerShown: false
        }}
        name="LabourSavourSchedule"
        component={LaborSavorSchedule}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: ' ClockIn - Workhappy',
          headerShown: false
        }}
        name="ClockIn"
        component={Clockin}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: ' Take a break - Workhappy',
          headerShown: false
        }}
        name="Takeabreak"
        component={Takebreak}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: ' End break - Workhappy',
          headerShown: false
        }}
        name="Endbreak"
        component={Endbreak}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: ' ClockOut - Workhappy',
          headerShown: false
        }}
        name="ClockOut"
        component={ClockOut}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: ' Transfer - Workhappy',
          headerShown: false
        }}
        name="Transfer"
        component={Transfer}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: ' Payroll Documents - Workhappy',
          headerShown: false
        }}
        name="PayrollDocuments"
        component={PayrollDocuments}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: ' Paystub Details - Workhappy',
          headerShown: false
        }}
        name="PayCheckDetails"
        component={PayCheckDetails}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: ' Update Direct Deposit - Workhappy',
          headerShown: false
        }}
        name="UpdateDirectDeposit"
        component={UpdateDeposit}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: ' Giveup Shift - Workhappy',
          headerShown: false
        }}
        name="Giveup"
        component={Giveup}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: ' W-2 - Workhappy',
          headerShown: false
        }}
        name="Vieww2 Forms"
        component={Vieww2}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{ headerShown: false }}
        name="Department Messages"
        component={DepartmentMessages}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{ headerShown: false }}
        name="Messages"
        component={OnboardedMessages}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{ headerShown: false }}
        name="MessageNew"
        component={MessageNew}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{ headerShown: false }}
        name="CommunicationwithDepartment"
        component={ChatScreen}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'Employee Resources - Workhappy',
          headerShown: false
        }}
        name="EmployeeResources"
        component={EmployeeResources}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'Employee Request PTO - Workhappy',
          headerShown: false
        }}
        name="EmployeeRequestPTO"
        component={EmployeeRequestPTO}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'pickup Request- Workhappy',
          headerShown: false
        }}
        name="pickupRequest"
        component={Pickup}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'SwapShift Request- Workhappy',
          headerShown: false
        }}
        name="SwapShift"
        component={SwapShift}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'Update Schedule Availability- Workhappy',
          headerShown: false
        }}
        name="UpdateScheduleAvailability"
        component={UpdateScheduleAvailability}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'W-4 Information- Workhappy',
          headerShown: false
        }}
        name="W4InformationForm"
        component={W4InformationForm}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'Edit Direct Deposit- Workhappy',
          headerShown: false
        }}
        name="Editdirectdeposit"
        component={Editdirectdeposit}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'I-9 Information- Workhappy',
          headerShown: false
        }}
        name="I9InformationForm"
        component={I9InformationForm}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'W-4 Information- Workhappy',
          headerShown: false
        }}
        name="W4preview"
        component={W4preview}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'DirectDeposit Information- Workhappy',
          headerShown: false
        }}
        name="Directdepositonline"
        component={Directdepositonline}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'I9 Information- Workhappy',
          headerShown: false
        }}
        name="I9informationonline"
        component={I9informationonline}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'Al Information- Workhappy',
          headerShown: false
        }}
        name="AlinformationForm"
        component={AlinformationForm}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'Al Information - Workhappy',
          headerShown: false
        }}
        name="Alonline"
        component={Alonline}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'Io Information - Workhappy',
          headerShown: false
        }}
        name="IoInformatiomForm"
        component={IoInformatiomForm}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'Io Information - Workhappy',
          headerShown: false
        }}
        name="Ioonline"
        component={Ioinformationonline}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'WOTC InformationForm - Workhappy',
          headerShown: false
        }}
        name="WotcInformationForm"
        component={WotcInformationForm}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'WOTC InformationForm - Workhappy',
          headerShown: false
        }}
        name="Wotconline"
        component={Wotconline}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'Personal Basic Information - Workhappy',
          headerShown: false
        }}
        name="UpdatePersonalBasicInformationScreen"
        component={UpdatePersonalBasicInformationScreen}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'Personal Basic Information - Workhappy',
          headerShown: false
        }}
        name="UpdateBasicInformationForm"
        component={UpdateBasicInformationForm}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'Personal contact Information - Workhappy',
          headerShown: false
        }}
        name="UpdateContactInformationForm"
        component={UpdateContactInformationForm}
        initialParams={{ ...params }}
      />

      <Stack.Screen
        options={{
          title: 'Personal Basic Information - Workhappy',
          headerShown: false
        }}
        name="UpdatePersonalContactInformationScreen"
        component={UpdatePersonalContactInformationScreen}
        initialParams={{ ...params }}
      />

      <Stack.Screen
        options={{
          title: 'LaInformationForm - Workhappy',
          headerShown: false
        }}
        name="LaInformationForm"
        component={LaInformationForm}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'LaInformation Online - Workhappy',
          headerShown: false
        }}
        name="LAInformationOnline"
        component={LAInformationOnline}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'GaInformationForm - Workhappy',
          headerShown: false
        }}
        name="GaInformationForm"
        component={GaInformationForm}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'GaInformation Online - Workhappy',
          headerShown: false
        }}
        name="GAInformationOnline"
        component={GAInformationOnline}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'CAInformationForm - Workhappy',
          headerShown: false
        }}
        name="CAinformationForm"
        component={CAinformationForm}
        initialParams={{ ...params }}
      />

      <Stack.Screen
        options={{
          title: 'CAInformation Online - Workhappy',
          headerShown: false
        }}
        name="CAInformationOnline"
        component={CAonline}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'ARInformationForm - Workhappy',
          headerShown: false
        }}
        name="ARinformationForm"
        component={ARinformationForm}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'ARInformation Online - Workhappy',
          headerShown: false
        }}
        name="ARInformationOnline"
        component={ARinformationonline}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'KyInformationForm - Workhappy',
          headerShown: false
        }}
        name="KyInformationForm"
        component={KyInformationForm}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'KyInformation Online - Workhappy',
          headerShown: false
        }}
        name="KyInformationonline"
        component={KyInformationonline}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'CtInformationForm - Workhappy',
          headerShown: false
        }}
        name="CtinformationForm"
        component={CtinformationForm}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'CtInformation Online - Workhappy',
          headerShown: false
        }}
        name="Ctonline"
        component={Ctonline}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'COInformationForm - Workhappy',
          headerShown: false
        }}
        name="CoinformationForm"
        component={CoinformationForm}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'COInformation Online - Workhappy',
          headerShown: false
        }}
        name="Coonline"
        component={Coonline}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'AZInformationForm - Workhappy',
          headerShown: false
        }}
        name="AZinformationForm"
        component={AZinformationForm}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'AZInformation Online - Workhappy',
          headerShown: false
        }}
        name="AZinformationonline"
        component={AZinformationonline}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'DCInformationForm - Workhappy',
          headerShown: false
        }}
        name="DCinformationForm"
        component={DCinformationForm}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'DCInformation Online - Workhappy',
          headerShown: false
        }}
        name="DCinformationonline"
        component={DConline}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'HIInformationForm - Workhappy',
          headerShown: false
        }}
        name="HiinformationForm"
        component={HiinformationForm}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'HIInformation Online - Workhappy',
          headerShown: false
        }}
        name="Hionline"
        component={Hionline}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'DEInformationForm - Workhappy',
          headerShown: false
        }}
        name="DeinformationForm"
        component={DeinformationForm}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'DEInformation Online - Workhappy',
          headerShown: false
        }}
        name="Deonline"
        component={Deonline}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'IdInformationForm - Workhappy',
          headerShown: false
        }}
        name="IdinformationForm"
        component={IdinformationForm}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'IdInformation Online - Workhappy',
          headerShown: false
        }}
        name="Idonline"
        component={Idonline}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'PAInformationForm - Workhappy',
          headerShown: false
        }}
        name="PainformationForm"
        component={PainformationForm}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'PA Information Online - Workhappy',
          headerShown: false
        }}
        name="Paonline"
        component={PaInformationonline}
        initialParams={{ ...params }}
      />

      <Stack.Screen
        options={{
          title: 'MAInformationForm - Workhappy',
          headerShown: false
        }}
        name="mainformationForm"
        component={MainformationForm}
        initialParams={{ ...params }}
      />

      <Stack.Screen
        options={{
          title: 'MA Information Online - Workhappy',
          headerShown: false
        }}
        name="maonline"
        component={MaInformationonline}
        initialParams={{ ...params }}
      />

      <Stack.Screen
        options={{
          title: 'MDInformationForm - Workhappy',
          headerShown: false
        }}
        name="mdinformationForm"
        component={MdInformationForm}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'MDInformationForm - Workhappy',
          headerShown: false
        }}
        name="mdonline"
        component={MdInformationOnline}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'KarnsInformationForm - Workhappy',
          headerShown: false
        }}
        name="karnsinformationForm"
        component={KarnsInformationForm}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'KarnsInformationOnline - Workhappy',
          headerShown: false
        }}
        name="karnsinformationOnline"
        component={KarnsInformationOnline}
        initialParams={{ ...params }}
      />

      <Stack.Screen
        options={{
          title: 'WC Rights And Duties Form For Karns - Workhappy',
          headerShown: false
        }}
        name="WCRightsInformationForm"
        component={WCRightsInformationForm}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'WC Rights And Duties Form For Karns - Workhappy',
          headerShown: false
        }}
        name="WCRightsonline"
        component={WCRightsInformationOnline}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'Equal Employment Opportunity - Workhappy',
          headerShown: false
        }}
        name="EEOInformationForm"
        component={EEOInformationForm}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'Equal Employment Opportunity - Workhappy',
          headerShown: false
        }}
        name="EEOInformationOnline"
        component={EEOInformationOnline}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'OKInformationForm - Workhappy',
          headerShown: false
        }}
        name="OkInformationForm"
        component={OkInformationForm}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'OKInformationForm - Workhappy',
          headerShown: false
        }}
        name="OkInformationOnline"
        component={OkInformationOnline}
        initialParams={{ ...params }}
      />

      <Stack.Screen
        options={{
          title: 'Kansas State Withholding Form - Workhappy',
          headerShown: false
        }}
        name="KsinformationForm"
        component={KsinformationForm}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'Kansas State Withholding Form - Workhappy',
          headerShown: false
        }}
        name="KsinformationOnline"
        component={KsinformationOnline}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'VaInformationForm - Workhappy',
          headerShown: false
        }}
        name="VaInformationForm"
        component={VaInformationForm}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'VaInformationOnline - Workhappy',
          headerShown: false
        }}
        name="VaInformationOnline"
        component={VaInformationOnline}
        initialParams={{ ...params }}
      />

      <Stack.Screen
        options={{
          title: '8850 InformationOnline - Workhappy',
          headerShown: false
        }}
        name="Form8850InformationForm"
        component={Form8850InformationForm}
        initialParams={{ ...params }}
      />

      <Stack.Screen
        options={{
          title: '8850 InformationOnline - Workhappy',
          headerShown: false
        }}
        name="Form8850InformationOnline"
        component={Form8850InformationOnline}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'OrInformationForm - Workhappy',
          headerShown: false
        }}
        name="OrInformationForm"
        component={OrInformationForm}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'OrInformationOnline - Workhappy',
          headerShown: false
        }}
        name="OrInformationOnline"
        component={OrInformationOnline}
        initialParams={{ ...params }}
      />

      <Stack.Screen
        options={{
          title: 'MoInformationOnline - Workhappy',
          headerShown: false
        }}
        name="MoInformationform"
        component={MoInformationform}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'MoInformationOnline - Workhappy',
          headerShown: false
        }}
        name="MoInformationonline"
        component={MoInformationonline}
        initialParams={{ ...params }}
      />

      <Stack.Screen
        options={{
          title: 'Grocery Basket Employee Handbook - Workhappy',
          headerShown: false
        }}
        name="HandBookOnline"
        component={HandBookOnline}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'Grocery Basket Cellphone Policy - Workhappy',
          headerShown: false
        }}
        name="CellPhonePolicy"
        component={CellPhonePolicy}
        initialParams={{ ...params }}
      />

      <Stack.Screen
        options={{
          title: 'MsInformationOnline - Workhappy',
          headerShown: false
        }}
        name="MsInformationform"
        component={MsInformationform}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'MsInformationOnline - Workhappy',
          headerShown: false
        }}
        name="MsInformationOnline"
        component={MsInformationOnline}
        initialParams={{ ...params }}
      />


      <Stack.Screen
        options={{
          title: 'ILInformationOnline - Workhappy',
          headerShown: false
        }}
        name="IlInformationForm"
        component={IlInformationForm}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'ILInformationOnline - Workhappy',
          headerShown: false
        }}
        name="IlInformationOnline"
        component={IlInformationOnline}
        initialParams={{ ...params }}
      />

      <Stack.Screen
        options={{
          title: 'WiInformationForm - Workhappy',
          headerShown: false
        }}
        name="WiInformationForm"
        component={WiInformationForm}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'WiInformationOnline - Workhappy',
          headerShown: false
        }}
        name="WiInformationOnline"
        component={WiInformationOnline}
        initialParams={{ ...params }}
      />


      <Stack.Screen
        options={{
          title: 'InInformationForm - Workhappy',
          headerShown: false
        }}
        name="InInformationForm"
        component={InInformationForm}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'InInformationOnline - Workhappy',
          headerShown: false
        }}
        name="InInformationOnline"
        component={InInformationOnline}
        initialParams={{ ...params }}
      />

      <Stack.Screen
        options={{
          title: 'MTInformationForm - Workhappy',
          headerShown: false
        }}
        name="MtInformationForm"
        component={MtInformationForm}
        initialParams={{ ...params }}
      />

      <Stack.Screen
        options={{
          title: 'MTInformationOnline - Workhappy',
          headerShown: false
        }}
        name="MtInformationOnline"
        component={MtInformationOnline}
        initialParams={{ ...params }}
      />

      <Stack.Screen
        options={{
          title: 'RIInformationForm - Workhappy',
          headerShown: false
        }}
        name="RiInformationForm"
        component={RiInformationForm}
        initialParams={{ ...params }}
      />

      <Stack.Screen
        options={{
          title: 'RIInformationOnline - Workhappy',
          headerShown: false
        }}
        name="RiInformationOnline"
        component={RiInformationOnline}
        initialParams={{ ...params }}
      />


      <Stack.Screen
        options={{
          title: 'NEInformationForm - Workhappy',
          headerShown: false
        }}
        name="NeInformationForm"
        component={NeInformationForm}
        initialParams={{ ...params }}
      />

      <Stack.Screen
        options={{
          title: 'NEInformationOnline - Workhappy',
          headerShown: false
        }}
        name="NeInformationOnline"
        component={NeInformationOnline}
        initialParams={{ ...params }}
      />

      <Stack.Screen
        options={{
          title: 'ScInformationForm - Workhappy',
          headerShown: false
        }}
        name="ScInformationForm"
        component={ScInformationForm}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'ScInformationOnline - Workhappy',
          headerShown: false
        }}
        name="ScInformationOnline"
        component={ScInformationOnline}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'VtInformationForm - Workhappy',
          headerShown: false
        }}
        name="VtInformationForm"
        component={VtInformationForm}
        initialParams={{ ...params }}
      />

      <Stack.Screen
        options={{
          title: 'VtInformationOnline - Workhappy',
          headerShown: false
        }}
        name="VtInformationOnline"
        component={VtInformationOnline}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'WVInformationForm - Workhappy',
          headerShown: false
        }}
        name="WvInformationForm"
        component={WvInformationForm}
        initialParams={{ ...params }}
      />

      <Stack.Screen
        options={{
          title: 'WVInformationOnline - Workhappy',
          headerShown: false
        }}
        name="WvInformationOnline"
        component={WvInformationOnline}
        initialParams={{ ...params }}
      />

      <Stack.Screen
        options={{
          title: 'MEInformationForm - Workhappy',
          headerShown: false
        }}
        name="MeInformationForm"
        component={MeInformationForm}
        initialParams={{ ...params }}
      />

      <Stack.Screen
        options={{
          title: 'MEInformationOnline - Workhappy',
          headerShown: false
        }}
        name="MeInformationOnline"
        component={MeInformationOnline}
        initialParams={{ ...params }}
      />

      <Stack.Screen
        options={{
          title: 'OHInformationForm - Workhappy',
          headerShown: false
        }}
        name="OhInformationForm"
        component={OhInformationForm}
        initialParams={{ ...params }}
      />

      <Stack.Screen
        options={{
          title: 'OHInformationOnline - Workhappy',
          headerShown: false
        }}
        name="OhInformationOnline"
        component={OhInformationOnline}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'MiInformationForm - Workhappy',
          headerShown: false
        }}
        name="MiInformationForm"
        component={MiInformationForm}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'MiInformationOnline - Workhappy',
          headerShown: false
        }}
        name="MiInformationOnline"
        component={MiInformationOnline}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'CanarayForm - Workhappy',
          headerShown: false
        }}
        name="CanarayForm"
        component={CanarayForm}
        initialParams={{ ...params }}
      />

      <Stack.Screen
        options={{
          title: 'NJInformationForm - Workhappy',
          headerShown: false
        }}
        name="NjInformationForm"
        component={NjInformationForm}
        initialParams={{ ...params }}
      />


      <Stack.Screen
        options={{
          title: 'NJInformationOnline - Workhappy',
          headerShown: false
        }}
        name="NjInformationOnline"
        component={NjInformationOnline}
        initialParams={{ ...params }}
      />



      <Stack.Screen
        options={{
          title: 'NmInformationForm - Workhappy',
          headerShown: false
        }}
        name="NmInformationForm"
        component={NmInformationForm}
        initialParams={{ ...params }}
      />

      <Stack.Screen
        options={{
          title: 'NmInformationOnline - Workhappy',
          headerShown: false
        }}
        name="NmInformationOnline"
        component={NmInformationOnline}
        initialParams={{ ...params }}
      />

      <Stack.Screen
        options={{
          title: 'NcInformationForm - Workhappy',
          headerShown: false
        }}
        name="NcInformationForm"
        component={NcInformationForm}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'NcInformationOnline - Workhappy',
          headerShown: false
        }}
        name="NcInformationOnline"

        component={NcInformationOnline}
        initialParams={{ ...params }}
      />

      <Stack.Screen
        options={{
          title: 'RedmondsOperationsOnline - Workhappy',
          headerShown: false
        }}
        name="Operations"
        component={Operations}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'RedmondsHandBookOnline - Workhappy',
          headerShown: false
        }}
        name="HandBook"
        component={HandBook}
        initialParams={{ ...params }}
      />


      <Stack.Screen
        options={{
          title: 'NyInformationForm - Workhappy',
          headerShown: false
        }}
        name="NyInformationForm"
        component={NyInformationForm}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'NyInformationOnline - Workhappy',
          headerShown: false
        }}
        name="NyInformationOnline"
        component={NyInformationOnline}
        initialParams={{ ...params }}
      />

      <Stack.Screen
        options={{
          title: 'RobertsAcknowledgementOnline - Workhappy',
          headerShown: false
        }}
        name="RobertsAcknowledgement"
        component={RobertsAcknowledgement}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'MnInformationForm - Workhappy',
          headerShown: false
        }}
        name="MnInformationForm"
        component={MnInformationForm}
        initialParams={{ ...params }}
      />

      <Stack.Screen
        options={{
          title: 'MnInformationOnline - Workhappy',
          headerShown: false
        }}
        name="MnInformationOnline"
        component={MnInformationOnline}
        initialParams={{ ...params }}
      />

      <Stack.Screen
        options={{
          title: 'PAInformationForm - Workhappy',
          headerShown: false
        }}
        name="painformationTable"
        component={PainformationTable}
        initialParams={{ ...params }}
      />

      <Stack.Screen
        options={{
          title: 'HandBookSignOffOnline - Workhappy',
          headerShown: false
        }}
        name="HandBookSignOffForm"
        component={HandBookSignOffForm}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'HandBookSignOffOnline - Workhappy',
          headerShown: false
        }}
        name="HandBookSignOffOnline"
        component={HandBookSignOffOnline}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'Wakefield IGA - Workhappy',
          headerShown: false
        }}
        name="WakefieldAcknowledgment"
        component={Acknowledgment}
        initialParams={{ ...params }}
      />

      <Stack.Screen
        options={{
          title: 'Rons Handbook - Workhappy',
          headerShown: false
        }}
        name="RonsHandBook"
        component={RonsHandBook}
        initialParams={{ ...params }}
      />

      <Stack.Screen
        options={{
          title: 'Cypress Creek Acknowledgements - Workhappy',
          headerShown: false
        }}
        name="CityMarketsAcknowledgement"
        component={CityMarketsAcknowledgement}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'Davis Team Discount Policy - Workhappy',
          headerShown: false
        }}
        name="DavisTeamDiscountPolicy"
        component={DavisTeamDiscountPolicy}
        initialParams={{ ...params }}
      />


      <Stack.Screen
        options={{
          title: 'Food Country Form - Workhappy',
          headerShown: false
        }}
        name="FoodCountryForm"
        component={FoodCountryForm}
        initialParams={{ ...params }}
      />

      <Stack.Screen
        options={{
          title: 'Weekly Summary - Workhappy',
          headerShown: false
        }}
        name="WeeklySummary"
        component={WeeklySummary}
        initialParams={{ ...params }}
      />

      <Stack.Screen
        options={{
          title: 'Announcements - Workhappy',
          headerShown: false
        }}
        name="AnnouncementsScreen"
        component={AnnouncementsScreen}
        initialParams={{ ...params }}
      />

      <Stack.Screen
        options={{
          title: 'Galens Acknowledgement - Workhappy',
          headerShown: false
        }}
        name="GalensAcknowledgement"
        component={GalensAcknowledgement}
        initialParams={{ ...params }}
      />

      <Stack.Screen
        options={{
          title: 'PTO Request History - Workhappy',
          headerShown: false
        }}
        name="PTORequestHistory"
        component={PTORequestHistory}
        initialParams={{ ...params }}
      />


      <Stack.Screen
        options={{
          title: 'Timecard - Workhappy',
          headerShown: false
        }}
        name="TimeCard"
        component={TimeCard}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'Messages - Workhappy',
          headerShown: false
        }}
        name="CommunicateWithEmployee"
        component={CommunicateWithEmployee}
        initialParams={{ ...params }}
      />

      {SecondaryStack(Stack, params)}
    </Stack.Navigator>
  )
}

export default HomeStack
